
export * from '../shared'

const alignments = {
  start: 'flex-start',
  end: 'flex-end',
  around: 'space-around',
  between: 'space-between'
}

export const align = v => {
  return {
    justifyContent: alignments[v] || v,
    alignItems: alignments[v] || v
  }
}

export const alignX = v => {
  return {
    justifyContent: alignments[v] || v
  }
}

export const alignY = v => {
  return {
    alignItems: alignments[v] || v
  }
}